import script from "./StudentCourseList.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentCourseList.vue?vue&type=script&setup=true&lang=js"

import "./StudentCourseList.vue?vue&type=style&index=0&id=0d9caf7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9caf7b"]])

export default __exports__